import React from "react";
import "./ImageSection.scss";

// Components
import { IonLabel, IonNote } from "@ionic/react";
import InputFactory from "../../../components/Factories/Input/InputFactory";

// Types
import { ChangeEvent } from "react";

type ImageSectionProps = {
  title: string;
  name: string;
  value: File | null;
  exampleImage?: string;
  noInputLabel?: boolean;
  text?: string;
  label?: string;
  errors: any;
  minDimensions: {
    width: number;
    height: number;
  };
  changeHandler: (event: ChangeEvent<HTMLInputElement>) => void;
};

export default function ImageSection(props: ImageSectionProps) {
  const { title, name, minDimensions, text, exampleImage, noInputLabel, label, errors, value, changeHandler } = props;
  const minDimensionsString = `${minDimensions.width} x ${minDimensions.height}px`;
  const fileUrl = value instanceof File ? URL.createObjectURL(value) : value;

  return (
    <section className="settings-image-section">
      <h3>{title}</h3>

      {text ? (
        <>
          <p>{text}</p>
          <p>Format: png - Min dimensions {minDimensionsString}.</p>
        </>
      ) : (
        <>
          <p>Please ensure that there is enough contrast between your logo and the header background colour.</p>
          <p>We recommend uploading a .png image to maintain the transparency.</p>
          <p>See 'Colours' section below.</p>
          <p>Format: png - Min dimensions {minDimensionsString}.</p>
        </>
      )}

      <div className="settings-image-section__input">
        <div className={`input__container input__container--type-image ${errors?.[name] && "has-error"}`}>
          {!noInputLabel && <IonLabel>{label || "Upload your logo"}</IonLabel>}
          <InputFactory id={name} name={name} type="image" value={fileUrl} accept={".png"} onIonChange={changeHandler} />
          {errors?.[name] && <IonNote color="danger">{errors?.[name][0]}</IonNote>}

          {exampleImage && (
            <>
              <IonLabel className="settings-image-section__example__label">Belong example</IonLabel>
              <div className="settings-image-section__example__image">
                <img src={exampleImage} alt="Example using the Belong logo" />
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
